interface Args {
  file: { created_by: string | null }
  allowed: boolean
  foreignAllowed: boolean
  currentUserId: string
}

export function showFileAction({
  file,
  allowed,
  foreignAllowed,
  currentUserId
}: Args) {
  if (foreignAllowed) return true

  return allowed && file?.created_by === currentUserId
}
